module.exports = {
    controller: hs2022forwardController,
    templateUrl: 'correlation-table/components/hs-2022-forward-page.html'
};

hs2022forwardController.$inject = ['$analytics'];

function hs2022forwardController($analytics) {

    var vm = {
        $onInit: attached
    };

    function attached() {
        $analytics.pageTrack('/correlation-table/hs2022');
    }
    
    return vm;
}
